export const LANDING_FIELD_BAR_CLASSES =
  "flex items-center gap-2 rounded-2xl border border-border bg-surface p-2 shadow-lg shadow-brand/10 transition-colors focus-within:border-brand";
